module.exports = __webpack_public_path__ + "img/green-arrow-right.dadad661.svg";